var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('div',{staticClass:"d-flex container",attrs:{"id":"navbar"}},[_c('div',{staticStyle:{"display":"flex"}},[_c('router-link',{attrs:{"to":"/propostas"}},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/orion-white.png"),"alt":""}})])],1),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.logOut}},[_vm._v("SAIR")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }